import { GfFlyerReviewChangeRequest } from "@swagger/typescript-fetch-goflyer";
import { messages } from "../../../../../locales/messages";

type StatusColor = "default" | "info" | "success" | "warning" | "error";

const S = GfFlyerReviewChangeRequest.StatusEnum;

export const CR_STATUS_COLORS: Record<
  GfFlyerReviewChangeRequest.StatusEnum,
  StatusColor
> = {
  [S.PENDING]: "info",
  [S.ACCEPTED]: "success",
  [S.REJECTED]: "error",
  [S.SUPERSEDED]: "warning",
  [S.RESTORED]: "default",
};

type StatusLabelFactory = () => ReturnType<typeof messages.Cr_Status_Pending>;

export const CR_STATUS_LABEL_FACTORIES: Record<
  GfFlyerReviewChangeRequest.StatusEnum,
  StatusLabelFactory
> = {
  [S.PENDING]: () => messages.Cr_Status_Pending(),
  [S.ACCEPTED]: () => messages.Cr_Status_Accepted(),
  [S.REJECTED]: () => messages.Cr_Status_Rejected(),
  [S.SUPERSEDED]: () => messages.Cr_Status_Superseded(),
  [S.RESTORED]: () => messages.Cr_Status_Restored(),
};
